

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  menuList: any[] = [];
  pageList: any[] = [];
  selectedItem: string | null = null;
  isApplicant = false;
  isEmployee = false;

  constructor(private userService: UserService, private router: Router) {}

  ngOnInit(): void {

    const storedMenuList = localStorage.getItem('menuList');

    if (storedMenuList) {
      this.menuList = JSON.parse(storedMenuList);
    }

    for (let menu of this.menuList) {
      if (menu.KHB_MenuName === 'Applicant') {
        this.pageList = menu.BSHB_PagesList;
        this.isApplicant = true;
      }
      if (menu.KHB_MenuName === 'Administration') {
        this.pageList = menu.BSHB_PagesList;
        this.isEmployee = true;
      }
    }
  }

  listClick(event: Event, newValue: string, KM_Id: string): void {
    localStorage.setItem('selectedMenu', newValue);
    this.selectedItem = newValue;
  }

  toggleSidebar() {
    document.body.classList.toggle('open-sidebar');
  }
}


// WEBPACK FOOTER //
// ./src/app/homepage/homepage.component.ts